const accountInfoTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "mainContainer"
            },
            "tag": "section",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": 1
        },
        "23": {
            "config": {
                "class": "add-account"
            },
            "tag": "div",
            "parent": 2
        },
        "24": {
            "config": {},
            "tag": "h6",
            "parent": 23,
            "html": "Account(s) Added"
        },
        "25": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 23
        },
        "26": {
            "config": {
                "class": "col"
            },
            "tag": "div",
            "parent": 25
        },
        "27": {
            "config": {
                "class": "owl-carousel owl-theme"
            },
            "tag": "div",
            "parent": 26,
            "html": ""
        },
        "28": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 23,
            "html": ""
        },
        "29": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 28,
            "html": ""
        },
        "30": {
            "config": {
                "style": {
                    "float": "right"
                },
                // "target": "blank",
                "href": "javascript:void(0)",
                "class": "btn btn-sm btn-primary moreInf mt-3",
                "id": "statsLinkButton"
            },
            "tag": "a",
            "parent": 29,   
            "html": "More Information",
            "events": [
                {
                    "id": "statsLinkButton",
                    "name": "click",
                    "callback": "navigateToLink"
                }
            ]
        },
        "31": {
            "config": {
                "class": "card p-0 mt-4",
            },
            "tag": "div",
            "parent": 39
        },
        "32": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 31
        },
        "33": {
            "config": {},
            "tag": "h4",
            "parent": 32,
            "html": "Bank Account Summary"
        },
        "34": {
            "config": {
                "class": "data-wrap data-border no-striped"
            },
            "tag": "div",
            "parent": 32
        },
        "35": {
            "config": {
                "class": "row data-head borderbottom m-0 BASHeader"
            },
            "tag": "div",
            "parent": 34
        },
        "36": {
            "config": {
                "class": "data-body BASRow"
            },
            "tag": "div",
            "parent": 34
        },
        "37": {
            "config": {
                "class": "row m-0",
                "style": {"display":"none"},
                "id": "bankAccountSummaryInfo"
            },
            "tag": "div",
            "parent": 2,
            "html": ""
        },
        "38": {
            "config": { "class": "mt-3" },
            "tag": "h4",
            "parent": 32,
            "html": "Bank Account Statements"
        },
        "39": {
            "config": {
                "class": "col-12",
            },
            "tag": "div",
            "parent": 37,
            "html": ""
        },

        "40": {
            "config": { "class": "col-12" },
            "tag": "div",
            "parent": 37,
            "html": ""
        },
        "41": {
            "config": {
                "class": "card p-0 mt-4",
                "id": "overview-graphs"
            },
            "tag": "div",
            "parent": 39
        },
        "42": {
            "config": {
                "class": "card-body"
            },
            "tag": "div",
            "parent": 41
        },
        "43": {
            "config": { "class": "mt-3" },
            "tag": "h4",
            "parent": 42,
            "html": "Distribution of credits and debits by account"
        },
        "44": {
            "config": { "class": "row" },
            "tag": "div",
            "parent": 42
        },        
        "45": {
            "config": { "class": "avgNoOfCreditsPieChartWrapper col-3" },
            "tag": "div",
            "parent": 44
        },
        "46": {
            "config": {},
            "tag": "strong",
            "parent": 45,
            "html": "Average # Credits/Month By Account"
        },
        "47": {
            "config": { "id": "avgNoOfCreditsPieChart" },
            "tag": "div",
            "parent": 45
        },
        "48": {
            "config": { "class": "distribution-legends chart-legends" },
            "tag": "div",
            "parent": 45
        },
        "49": {
            "config": { "class": "avgNoOfDebitsPieChartWrapper col-3" },
            "tag": "div",
            "parent": 44
        },
        "50": {
            "config": {},
            "tag": "strong",
            "parent": 49,
            "html": "Average # Debits/Month By Account"
        },    
        "51": {
            "config": { "id": "avgNoOfDebitsPieChart" },
            "tag": "div",
            "parent": 49
        },
        "52": {
            "config": { "class": "distribution-legends chart-legends" },
            "tag": "div",
            "parent": 49
        },
        // "53": {
        //     "config": { "class": "mt-3" },
        //     "tag": "h4",
        //     "parent": 42,
        //     "html": "&nbsp"
        // },
        // "54": {
        //     "config": { "class": "row" },
        //     "tag": "div",
        //     "parent": 42
        // },        
        "55": {
            "config": { "class": "avgAmountOfCreditsPieChartWrapper col-3" },
            "tag": "div",
            "parent": 44 //54
        },
        "56": {
            "config": {},
            "tag": "strong",
            "parent": 55,
            "html": "Average $ Credits/Month By Account"
        },
        "57": {
            "config": { "id": "avgAmountOfCreditsPieChart" },
            "tag": "div",
            "parent": 55
        },
        "58": {
            "config": { "class": "distribution-legends chart-legends" },
            "tag": "div",
            "parent": 55
        },
        "59": {
            "config": { "class": "avgAmountOfDebitsPieChartWrapper col-3" },
            "tag": "div",
            "parent": 44 //54
        },
        "60": {
            "config": {},
            "tag": "strong",
            "parent": 59,
            "html": "Average $ Debits/Month By Account"
        },    
        "61": {
            "config": { "id": "avgAmountOfDebitsPieChart" },
            "tag": "div",
            "parent": 59
        },
        "62": {
            "config": { "class": "distribution-legends chart-legends" },
            "tag": "div",
            "parent": 59
        },

        "63": {
            "config": { "class": "mt-5" },
            "tag": "h4",
            "parent": 42,
            "html": "Average Credits & Debits per transaction"
        },
        "70": {
            "config": {
                "class": "data-wrap-fixed row m-0 shadowNone"
            },
            "tag": "div",
            "parent": 32
        },


        "71": {
            "config": {
                "class": "data-wrap-fixed row m-0 shadowNone"
            },
            "tag": "div",
            "parent": 32
        },
        
        "72": {
            "config": {
                "class": "col-1 dataLeft-fixed-aci p-0"
            },
            "tag": "div",
            "parent": 71,
            "html": ""
        },
        "73": {
            "config": {
                "class": "col-2 dataLeft-fixed-aci1 p-0"
            },
            "tag": "div",
            "parent": 71,
            "html": ""
        },
        "81": {
            "config": {
                "class": "col-1 dataRight-fixed-aci1 p-0"
            },
            "tag": "div",
            "parent": 71,
            "html": ""
        },
        "82": {
            "config": {
                "class": "col-1 dataRight-fixed-aci2 p-0"
            },
            "tag": "div",
            "parent": 71,
            "html": ""
        },
        "83": {
            "config": {
                "class": "col-7 p-0"
            },
            "tag": "div",
            "parent": 71
        },
        "84": {
            "config": {
                "id": "statements_info_rows",
                "class": "mid-panel  mid-panel-aci"
            },
            "tag": "div",
            "parent": 83
        },
        // "85": {
        //     "config": {
        //         "class": "data-head data-head-aci ht30"
        //     },
        //     "tag": "div",
        //     "parent": 84,
        //     "html": ""
        // },


        "95": {
            "config": {
                "class": "col-1 dataLeft-fixed-acih p-0"
            },
            "tag": "div",
            "parent": 70,
            "html": ""
        },
        "96": {
            "config": {
                "class": "col-2 dataLeft-fixed-acih1 p-0"
            },
            "tag": "div",
            "parent": 70,
            "html": ""
        },
        "97": {
            "config": {
                "class": "col-1 dataRight-fixed-acih1 p-0"
            },
            "tag": "div",
            "parent": 70,
            "html": ""
        },
        "98": {
            "config": {
                "class": "col-1 dataRight-fixed-acih2 p-0"
            },
            "tag": "div",
            "parent": 70,
            "html": ""
        },
        "99": {
            "config": {
                "class": "col-7 p-0 ht60",
                "style": {"overflow-y": "hidden"}
            },
            "tag": "div",
            "parent": 70
        },
        "100": {
            "config": {
                "id": "statements_info_header",
                "class": "mid-panel  mid-panel-acih"
            },
            "tag": "div",
            "parent": 99//83
        },
        "101": {
            "config": {
                "class": "data-head data-head-acih ht30"
            },
            "tag": "div",
            "parent": 100,
            "html": ""
        }
    };

    const card_item = {
        "1": {
            "config": {
                "class": "item"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "card active"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "card-header p-0"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "col-5"
            },
            "tag": "div",
            "parent": 4
        },
        "6": {
            "config": {
                "class": "brand"
            },
            "tag": "div",
            "parent": 5
        },
        "7": {
            "config": {
                "href": "javascript:void(0)"
            },
            "tag": "a",
            "parent": 6
        },
        "8": {
            "config": {
                "src": "{bank_name}",
                "onError": "this.onerror=null;this.src='https://d36kr2on5nrk8s.cloudfront.net/images/defaultbank.png';",
                "class": "img-fluid",
                "id": "imageLoadError",
            },
            "tag": "img",
            "parent": 7,
            "html": ""
        },
        "9": {
            "config": {
                "class": "col-7 p-0"
            },
            "tag": "div",
            "parent": 4
        },
        "10": {
            "config": {},
            "tag": "h5",
            "parent": 9,
            "html": "{bank_name}"
        },
        "11": {
            "config": {
                "style": {
                    "font-weight": "bold"
                }
            },
            "tag": "span",
            "parent": 9,
            "html": "A/C : {callback stringMasking account_number}"
        },
        "12": {
            "config": {
                "class": "card-body p-0 pt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "13": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 12
        },
        "14": {
            "config": {
                "class": "col"
            },
            "tag": "div",
            "parent": 13
        },
        "15": {
            "config": {},
            "tag": "p",
            "parent": 14
        },
        "16": {
            "config": {},
            "tag": "strong",
            "parent": 15,
            "html": "Selected Range : {duration_months_actual.length} Month(s)"
        },
        "17": {
            "config": {},
            "tag": "p",
            "parent": 15,
            "html": "{callback dateFormate from_date} to {callback dateFormate to_date}"
        },
        "18": {
            "config": {
                "class": "row tocreditrow"
            },
            "tag": "div",
            "parent": 12
        },
        "19": {
            "config": {
                "class": "col total credits"
            },
            "tag": "div",
            "parent": 18
        },
        "21": {
            "config": {
                "class": "totalInner"
            },
            "tag": "div",
            "parent": 19
        },
        "22": {
            "config": {
                "class": "price"
            },
            "tag": "div",
            "parent": 21
        },
        "23": {
            "config": {
                "class": "user"
            },
            "tag": "span",
            "parent": 22,
            "html": "{no_of_credits}<br>{callback separateNumberByCommaAndRoundOffwithSign credits}" //callback roundOff
        },
        "25": {
            "config": {},
            "tag": "h6",
            "parent": 21,
            "html": "Total Credits"
        },
        "26": {
            "config": {
                "class": "col total debits"
            },
            "tag": "div",
            "parent": 18
        },
        "28": {
            "config": {
                "class": "totalInner"
            },
            "tag": "div",
            "parent": 26
        },
        "29": {
            "config": {
                "class": "price"
            },
            "tag": "div",
            "parent": 28
        },
        "30": {
            "config": {
                "class": "user"
            },
            "tag": "span",
            "parent": 29,
            "html": "{no_of_debits}<br>{callback separateNumberByCommaAndRoundOffwithSign debits}" // separateNumberByDelimiter
        },
        "32": {
            "config": {},
            "tag": "h6",
            "parent": 28,
            "html": "Total Debits"
        },
        "33": {
            "config": {
                "class": "price"
            },
            "tag": "div",
            "parent": 28
        },
        "34": {
            "config": {
                "class": "user"
            },
            "tag": "span",
            "parent": 33,
            "html": "{callback separateNumberByCommaAndRoundOffwithSign average_debits}"
        },
        "35": {
            "config": {},
            "tag": "h6",
            "parent": 28,
            "html": "Average Debits"
        },
        "36": {
            "config": {
                "class": "price"
            },
            "tag": "div",
            "parent": 21
        },
        "37": {
            "config": {
                "class": "user"
            },
            "tag": "span",
            "parent": 36,
            "html": "{callback separateNumberByCommaAndRoundOffwithSign average_credits}"
        },
        "38": {
            "config": {},
            "tag": "h6",
            "parent": 21,
            "html": "Average Credits"
        }
    };
    return {
        main,
        card_item
    };
})();
